enum MouseFunction {
	NONE = "NONE",
	WATERMARK = "WATERMARK",
	ATTACHMENT = "ATTACHMENT",
	SIGNATURE = "SIGNATURE",
	NOTE = "NOTE",
	MARK = "MARK",
	UNDERLINE = "UNDERLINE",
	STRIKE = "STRIKE",
	SQUIGGLY = "SQUIGGLY",
	LINE = "LINE",
	SQUARE = "SQUARE",
	CIRCLE = "CIRCLE",
	BARCODE_CREATE = "BARCODE_CREATE",
	BARCODE_CREATE_SWISS_CODE = "BARCODE_CREATE_SWISS_CODE",
	BARCODE_CREATE_SWISS_BILL = "BARCODE_CREATE_SWISS_BILL",
	BARCODE_CREATE_SWISS_BILL_WITH_SPACE = "BARCODE_CREATE_SWISS_BILL_WITH_SPACE",
	BARCODE_DETECT = "BARCODE_DETECT",
	REDACT_TEXT = "REDACT_TEXT",
	REDACT_AREA = "REDACT_AREA",
	STAMP_APPROVED = "STAMP_APPROVED",
	STAMP_EXPERIMENTAL = "STAMP_EXPERIMENTAL",
	STAMP_NOT_APPROVED = "STAMP_NOT_APPROVED",
	STAMP_AS_IS = "STAMP_AS_IS",
	STAMP_EXPIRED = "STAMP_EXPIRED",
	STAMP_NOT_FOR_PUBLIC_RELEASE = "STAMP_NOT_FOR_PUBLIC_RELEASE",
	STAMP_CONFIDENTIAL = "STAMP_CONFIDENTIAL",
	STAMP_FINAL = "STAMP_FINAL",
	STAMP_SOLD = "STAMP_SOLD",
	STAMP_DEPARTMENTAL = "STAMP_DEPARTMENTAL",
	STAMP_FOR_COMMENT = "STAMP_FOR_COMMENT",
	STAMP_TOP_SECRET = "STAMP_TOP_SECRET",
	STAMP_DRAFT = "STAMP_DRAFT",
	STAMP_FOR_PUBLIC_RELEASE = "STAMP_FOR_PUBLIC_RELEASE",
	STAMP_CUSTOM = "STAMP_CUSTOM",
	FORMS_EDIT = "FORMS_EDIT"
}

export default MouseFunction;